import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import {TransactionPurposeTypeService} from '../transaction-purpose-type.service';
import {ITransactionPurposeType} from '../transaction-purpose-type';
import { Message } from 'primeng/primeng';
import { Router } from '@angular/router';


@Component({
  selector: 'app-transaction-purpose-type-crud',
  templateUrl: './transaction-purpose-type-crud.component.html',
  styleUrls: ['./transaction-purpose-type-crud.component.css'],
  providers: [TransactionPurposeTypeService]
})
export class TransactionPurposeTypeCrudComponent implements OnInit {

  id: any = null;	
  transactionPurposeType: ITransactionPurposeType;
  button_caption: string = 'Сохранить';
  button_icon: string = "fa fa-save";
  msgs: Message[] = [];

  constructor(	private location: Location,
    private router: Router,  
      private activatedRoute: ActivatedRoute,
      private transactionPurposeTypeService: TransactionPurposeTypeService) { 

        activatedRoute.params.subscribe(params=>{this.id=params['id']});

        if(this.id){
          this.transactionPurposeTypeService.getTransactionPurposeTypeById(this.id).subscribe(response => this.transactionPurposeType=response['data']);
          this.button_caption="Редактировать";
          this.button_icon="fa fa-edit";
        }else{
        }	
      }

  ngOnInit() {
  	this.transactionPurposeType = {id: '', name: '', description: '', available: true};
  }

  backClicked() {
        this.location.back();
  }

  crud(form: NgForm){
  		if(!this.id){
  			this.transactionPurposeTypeService.createTransactionPurposeType(form.value).subscribe(
  				(data) => {this.router.navigate(['dashboard/transaction-purpose-type/']);}
  				); 
  		}else{
  			this.transactionPurposeTypeService.updateTransactionPurposeType(form.value,this.id).subscribe(response =>{
          this.router.navigate(['dashboard/transaction-purpose-type/']);
        });
  		}
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/transaction_purpose_types/transaction-purpose-type-crud/transaction-purpose-type-crud.component.ts